export const OUTCOME_OPTIONS = [
  { value: "pending", label: "Awaiting outcome", color: "slate", tone: "bg-slate-100 text-slate-700 border-slate-200" },
  { value: "no_implantation", label: "No implantation", color: "red", tone: "bg-red-50 text-red-800 border-red-200" },
  { value: "biochemical", label: "Biochemical loss", color: "amber", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  { value: "clinical_pregnancy", label: "Clinical pregnancy", color: "sky", tone: "bg-sky-50 text-sky-800 border-sky-200" },
  { value: "ongoing_pregnancy", label: "Ongoing pregnancy", color: "indigo", tone: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  { value: "live_birth", label: "Live birth", color: "teal", tone: "bg-teal-50 text-teal-800 border-teal-200" },
  { value: "miscarriage", label: "Miscarriage", color: "rose", tone: "bg-rose-50 text-rose-800 border-rose-200" },
];

export const outcomeLabel = (v) =>
  (OUTCOME_OPTIONS.find((o) => o.value === v) || OUTCOME_OPTIONS[0]).label;

export const outcomeTone = (v) =>
  (OUTCOME_OPTIONS.find((o) => o.value === v) || OUTCOME_OPTIONS[0]).tone;

export const SUCCESS_OUTCOMES = new Set(["clinical_pregnancy", "ongoing_pregnancy", "live_birth"]);
